import { UPDATE_AFFILIATE_REQUEST, UPDATE_AFFILIATE_REQUEST_SUCCESS, UPDATE_AFFILIATE_REQUEST_FAILURE } from '../constants/update_affiliate.constants';

export const updateAffiliateRequest = payload => ({
    type: UPDATE_AFFILIATE_REQUEST, payload,
});

export const updateAffiliateRequestSuccess = payload => ({
    type: UPDATE_AFFILIATE_REQUEST_SUCCESS, payload,
});

export const updateAffiliateRequestFailure = error => ({
    type: UPDATE_AFFILIATE_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_update/redux/actions/update_affiliate.actions.js